import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FlatButton } from 'material-ui';
import injectSheet from 'react-jss';
import { defaultStyle } from './leftNav';
import { push as routerPush } from 'react-router-redux';
import { archiveConversation, getChannels } from './store/actions';

const styles = Object.assign({}, defaultStyle, {
  container: {
    display: 'flex',
    minHeight: '48px !important',
    backgroundColor: 'rgb(0, 179, 207)',
    alignItems: 'center',
    '&.loading': {
      cursor: 'wait',
    },
  },
  channelsTitle: {
    color: 'white',
    fontSize: '18px',
    flex: '1 0 auto',
    lineHeight: '48px',
    paddingLeft: '10px',
  },
  channel: {
    color: 'white !important',
    flex: '0 0 auto',
    minWidth: '68px !important',
    '&.disabled': {
      backgroundColor: 'rgb(0, 161, 186) !important',
    },
    '&.unread > div > span': {
      fontWeight: 'bolder !important',
    },
    marginRight: '20px !important',
  },
  popIconMenu: {
    height: '25px !important',
    width: '25px !important',
    '& div > svg': {
      width: '18px !important',
      height: '28px !important',
      marginTop: '-17px',
    },
  },
});

class ChannelList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    if (!this.timer) this.timer = setInterval(this.timedUpdate, 4e3);
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  timer = null
  timedUpdate = () => {
    if (!localStorage.stopAutoReload && !this.props.channelsFetching) this.props.getChannels();
  }
  render() {
    const { channelsFetching, channels, channelsTitle, companyName, selectedChannel, selectedConnection, selectedContract, classes } = this.props;
    const selectedItem = selectedChannel + ((selectedContract) ? `:${selectedContract}` : '');

    return selectedConnection ?
        <div className={`${classes.container} ${channelsFetching ? ' loading' : ''}`}>
          <div className={classes.channelsTitle}>{ channelsTitle }</div>
          {
            // channels.map(e => Object.assign({}, e, (e.channelId) ? {
            //   key: e.channelId,
            //   disabled: (selectedChannel === e.channelId),
            // } : {})).map(channel => (
            // <FlatButton
            //   key={channel.channelId}
            //   className={ `${classes.channel}${(channel.unread ? ' unread' : '')}${channel.disabled ? ' disabled' : ''}`}
            //   disabled={channel.disabled}
            //   label={(channel.text || '').replace(channelsTitle, '').replace(companyName, '')}
            //   onTouchTap={() => this.props.routerPush(`/workspace/${selectedConnection}/${channel.channelId}`)}
            // />
            // ))
          }
        </div>
        // Empty Connectionless content
        : (<div className={classes.container}>
            <div className={`${classes.channelsTitle}`}>Select a Channel</div>
          </div>
    );
  }
}
ChannelList.defaultProps = {
  channelsTitle: '',
};
ChannelList.propTypes = {
  archiveConversation: PropTypes.func,
  channels: PropTypes.array,
  channelsFetching: PropTypes.bool,
  channelsTitle: PropTypes.string,
  routerPush: PropTypes.func,
  selectedContract: PropTypes.string,
  selectedChannel: PropTypes.string,
  selectedConnection: PropTypes.string,
  classes: PropTypes.object,
  getChannels: PropTypes.func,
  companyName: PropTypes.string,
  className: PropTypes.string,
};

const select = (state) => ({
  channels: state.workspace.channels,
  channelsFetching: state.workspace.channelsFetching,
  channelsTitle: state.workspace.channelsTitle,
  selectedChannel: state.workspace.selectedChannel,
  selectedConnection: state.workspace.selectedConnection,
  selectedContract: state.workspace.selectedContract,
  companyName: state.user.getIn(['company', 'companyName']),
});
export default connect(select, {
  routerPush,
  archiveConversation,
  getChannels,
})(injectSheet(styles)(ChannelList));



// WEBPACK FOOTER //
// ./src/app/components/workspace/channel-list.jsx